import { render, staticRenderFns } from "./CMOverviewCourseGroupRow.vue?vue&type=template&id=5a828c8a&scoped=true&lang=pug&"
import script from "./CMOverviewCourseGroupRow.vue?vue&type=script&lang=js&"
export * from "./CMOverviewCourseGroupRow.vue?vue&type=script&lang=js&"
import style0 from "./CMOverviewCourseGroupRow.vue?vue&type=style&index=0&id=5a828c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a828c8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
